import { NavLink } from "react-router";

export const Page404 = () => {
  return (
    <>
      <main className="grid min-h-full place-items-center bg-delicate-50 px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-nunito font-semibold text-rust-400">
            404
          </p>
          <h1 className="mt-4 font-poppins text-balance text-5xl font-semibold tracking-tight text-slate-100 sm:text-7xl">
            Page not found
          </h1>
          <p className="mt-6 font-nunito text-pretty text-lg font-medium text-slate-50 sm:text-xl/8">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <NavLink
              to="/"
              className="font-semibold font-nunito text-rust-400 hover:text-rust-50"
            >
              <a
                href="#"
                className="rounded font-nunito bg-rust-400 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rust-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rust-400"
              >
                Go back home
              </a>
            </NavLink>
            {/* <a
              href="#"
              className="text-sm font-nunito font-semibold text-rust-400 hover:text-rust-50"
            >
              Contact support <span aria-hidden="true">&rarr;</span>
            </a> */}
          </div>
        </div>
      </main>
    </>
  );
};
